// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"Press_contactForm__gGPIS","contact":"Press_contact__xYHx9","label":"Press_label__ACJUP","value":"Press_value__yn8Zr"};